import React from 'react';
import { steamPerformanceAllReviewsTips } from '@op/components/BubbleCommon';
import { downloadAction } from '@op/components/DownloadCommon/download-page';
import useSteamUrl from '@op/hooks/useSteamUrl';
import usePcConsoleTimelineChart from '@op/pages/gamestore/hooks/usePcConsoleTimelineChart';
import ReviewsTimeline from '@op/pages/SteamPerformance/components/ReviewsTimeline';
import SteamGameStore from '@op/pages/SteamPerformance/components/SteamGameStore';
import { useEmptyInfo } from '@op/pages/SteamPerformance/hooks';
import { IRealtimeSteamAllReviews } from '../../type';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import CardCommon from '@op/components/CardCommon';


export default function SteamAllReviews(props: IRealtimeSteamAllReviews) {
  const { filter, gameInfo, wholeGameInfo, timelineData, userScore, timelineLoading } = props;

  function downloadReviewsInfo() {
    buriedBtnPoint('RO_Steam_AllReviews_Download');
    downloadAction({
      limit: 150000,
      downLoadParams: {
        ...filter,
        channel: ['steam'],
        valueKey: 'all_reviews',
        channels: ['steam'],
        metrics: ['recommend', 'non_recommend'],
        ret_metrics: ['recommend', 'non_recommend'],
        types: ['total', 'slice'],
      },
      downloadFunc: 'getOverviewPcConsoleTimeline',
      simpleName: 'Steam All Reviews',
      sheetName: 'Steam All Reviews',
    });
  }
  const { goToSteamUrl } = useSteamUrl({ gameInfo });

  const { chartMap } = usePcConsoleTimelineChart({
    platformData: timelineData,
    filterParams: filter,
  });

  const {
    chartData,
    chartEmpty,
    steamData,
    steamGameEmpty,
    allEmpty,
    emptyText,
  } = useEmptyInfo({
    chartMap,
    timelineKey: 'all_reviews',
    userScore: {
      'steam': userScore
    },
    keys: ['all_reviews', 'all_reviews_non_recommend', 'all_reviews_recommend'],
    wholeGameInfo,
    isRecent: false,
  });

  return (
    <>
      {/* <SteamGameStore
        title={'All Reviews'}
        keys={['all_reviews', 'all_reviews_non_recommend', 'all_reviews_recommend']}
        filter={filter}
        shareClick={goToSteamUrl}
        timeTips={"from the game's release on Steam to {time}"}
        nearTotalTips={steamPerformanceAllReviewsTips}
        data={steamData}
        hasDownload
        emptyHeight={allEmpty ? 0 : 104}
        empty={steamGameEmpty}
        hasEmptyDesc={!allEmpty}
        handleDownloadOnClick={() => downloadReviewsInfo()}
      ></SteamGameStore> */}
      <CardCommon
        className="timeline-box"
        contentCard
        hasDownload
        handleDownloadOnClick={() => downloadReviewsInfo()}
        loading={timelineLoading}
        empty={chartEmpty}
        emptyDescText={emptyText}
        emptyHeight={376}
      >
        <ReviewsTimeline
          filter={filter}
          isRecent={false}
          data={chartData}
          height={376}
        ></ReviewsTimeline>
      </CardCommon>
    </>
  );
}